<div class="upsell-popup" data-testid="upsell-popup">
  <div class="upsell-popup__header">Want to add this?</div>
  <div class="upsell-popup__body">
    <img *ngIf="suggestion?.imageData" [src]="suggestion.imageData" alt="" class="upsell-popup__image" />
    <div class="upsell-popup__details">
      <div class="upsell-popup__name">{{ suggestion?.name }}</div>
      <div class="upsell-popup__price">${{ ((suggestion?.price || 0) / 100).toFixed(2) }}</div>
      <div class="upsell-popup__reason">{{ suggestion?.reason | titlecase }}</div>
    </div>
  </div>
  <div class="upsell-popup__actions">
    <button type="button" class="upsell-popup__btn upsell-popup__btn--ghost" (click)="dismiss()" data-testid="upsell-popup-dismiss">No thanks</button>
    <button type="button" class="upsell-popup__btn upsell-popup__btn--primary" (click)="accept()" data-testid="upsell-popup-accept">Add to order</button>
  </div>
</div>
